// extracted by mini-css-extract-plugin
module.exports = {"content":"Description_content__2XGvS","columns":"Description_columns__30cEz","submitBtn":"Description_submitBtn__bq3y-"};